module.exports = __webpack_public_path__ + "img/Loudspeaker.b771394c.png";